import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CustomReportRead } from 'src/common/external/bambi-api/bambiApi';

export interface IReportsState {
  filters: {
    range_start?: string;
    range_end?: string;
    payerIds: string[];
    driverIds: string[];
    vehicleIds: string[];
  };
  customReportModal: {
    isOpen: boolean;
    report?: CustomReportRead | null;
  };
}

export const initialReportsState: IReportsState = {
  filters: {
    payerIds: [],
    driverIds: [],
    vehicleIds: [],
  },
  customReportModal: {
    isOpen: false,
  },
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState: initialReportsState,
  reducers: {
    setDateRange: (
      state,
      action: PayloadAction<{ range_start?: string; range_end?: string }>
    ) => {
      state.filters.range_start = action.payload.range_start;
      state.filters.range_end = action.payload.range_end;
    },
    setSelectedPayers: (state, action: PayloadAction<string[]>) => {
      state.filters.payerIds = action.payload;
    },
    setSelectedDrivers: (state, action: PayloadAction<string[]>) => {
      state.filters.driverIds = action.payload;
    },
    setSelectedVehicles: (state, action: PayloadAction<string[]>) => {
      state.filters.vehicleIds = action.payload;
    },
    clearFilters: (state) => {
      state.filters = { ...initialReportsState.filters };
    },
    openCustomReportModal: (state, action: PayloadAction<CustomReportRead>) => {
      state.customReportModal.isOpen = true;
      state.customReportModal.report = action.payload;
    },
    createCustomReport: (state) => {
      state.customReportModal.isOpen = true;
      state.customReportModal.report = null;
    },
    closeCustomReportModal: (state) => {
      state.customReportModal.isOpen = false;
      state.customReportModal.report = null;
    },
  },
});
